export const API_URL = 'https://api.vechain.energy/v1/event/main'
export const Events = {
  Transfer: 'event Transfer (address indexed _from, address indexed _to, uint256 indexed tokenId)'
}
